/* unplugin-vue-components disabled */import { render } from "./merchant_receive_success.vue?vue&type=template&id=4fe65bbb&scoped=true"
import script from "./merchant_receive_success.vue?vue&type=script&lang=js"
export * from "./merchant_receive_success.vue?vue&type=script&lang=js"

import "./merchant_receive_success.vue?vue&type=style&index=0&id=4fe65bbb&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe65bbb"]])

export default __exports__